// extracted by mini-css-extract-plugin
module.exports = {"root":"StickyBox_root__1OPfI","left":"StickyBox_left__2MObg","right":"StickyBox_right__kwBt1"};